export default () => {
  return { error: false, data: [] };
};
